import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/* Material Symbols paths are long single strings; keep intact for fidelity. */
/* eslint-disable max-len */

const TABLE_CHART_VIEW_OUTLINED_PATH =
    'm296-80-56-56 276-277 140 140 207-207 57 57-264 263-140-140L296-80Zm-136-40q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h560q33 0 56.5 23.5T800-760v168H160v472Zm0-552h560v-88H160v88Zm0 0v-88 88Z';

const TABLE_CHART_VIEW_FILLED_PATH =
    'm296-80-56-56 276-277 140 140 207-207 57 57-264 263-140-140L296-80Zm-136-40q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h560q33 0 56.5 23.5T800-760v168H160v472Z';

/* eslint-enable max-len */

/** Material Symbols `table_chart_view` outlined (FILL=0) */
export const TableChartViewOutlinedIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 -960 960 960">
        <path d={TABLE_CHART_VIEW_OUTLINED_PATH} />
    </SvgIcon>
);

/** Material Symbols `table_chart_view` filled (FILL=1) */
export const TableChartViewIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 -960 960 960">
        <path d={TABLE_CHART_VIEW_FILLED_PATH} />
    </SvgIcon>
);
